// extracted by mini-css-extract-plugin
module.exports = {"logoImage":"NavBar_logoImage__1a6Pd","backgroundGreen":"NavBar_backgroundGreen__2D8UD"};